<div class="create-category">
    <mat-card-title class="mat-display-1">
        <span>Kategorie erstellen</span>
    </mat-card-title>
    <div class="form">
        <mat-card>
            <div mat-icon-button mat-card-avatar class="list" routerLink="/category">
                <mat-icon>list</mat-icon>
            </div>
            <mat-card-content>
               
                <form [formGroup]="categoryForm" (ngSubmit)="submitForm()">
                    <div>
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" placeholder="Ihr Name hier">
                            <mat-hint align="end">Mindestens 4 Zeichen</mat-hint>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" cols="30" rows="10"></textarea>
                            <mat-hint align="end">Min 10 Zeichen</mat-hint>
                        </mat-form-field>
                  </div>
    
                    <mat-card-actions>
                        <button
                            mat-raised-button
                            color="primary"
                            [disabled]="categoryForm.invalid">
                            Speichern
                        </button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
